import React, { useState } from "react";
import { Col, Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import { Link } from "react-router-dom";
import Logo from "../../../assets/img/custom/logoForHome.png";

const youtubeLinks = [
  "https://youtu.be/nko4md-1nbk",
  "https://youtu.be/qp8VpDKthQM",
  "https://youtu.be/tDpaTmuntI0",
  "https://youtu.be/bGcZ8NOKK2E",
  "https://youtu.be/QkWaj8l__eA",
  "https://youtu.be/wxioQFcul-U",
];

const VISIBILITY_VIDEOS = [
  {
    label: "Athlete Boost Explainer",
    url: "https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/ATHLETEBOOSTVIDEO.mp4?alt=media&token=f7619800-2650-47b9-905a-944dbede78b8",
  },
  {
    label: "Fan Boost Explainer",
    url: "https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/FANBOOSTVIDEO.mp4?alt=media&token=07c181ba-3f49-4d1a-817c-c71b43dfd6b9",
  },
  {
    label: "Fan Manager Boost Explainer",
    url: "https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/MANAGERBOOSTVIDEO.mp4?alt=media&token=24a8f554-5742-4750-b363-0f8f42beb943",
  },
];

const customButtonStyle = {
  backgroundColor: "#1E90FF",
  borderColor: "#1E90FF",
  color: "white",
  width: "35px",
  height: "35px",
  padding: 0,
  fontSize: "1rem",
  fontWeight: "bold",
  borderRadius: "5px",
};

export default function HomeCenterCol({
  Modaltoggle,
  setCurrentVideoIndex,
}) {
  const [activeVisVideo, setActiveVisVideo] = useState(null);

  return (
    <Col lg="4" className="text-center">
      {/* Visibility Board Explainer Videos */}
      <div
        style={{
          border: "1.5px solid #d0d8f5",
          borderRadius: "20px",
          padding: "24px 28px 22px",
          backgroundColor: "#eef2ff",
          textAlign: "center",
          marginTop: "0",
          marginBottom: "8px",
        }}
      >
        <p
          style={{
            fontWeight: "800",
            fontSize: "18px",
            color: "#111",
            marginBottom: "20px",
          }}
        >
          Visibility Board Explainer Videos
        </p>
        {/* Row 1 — 2 buttons */}
        <div style={{ display: "flex", gap: "16px", marginBottom: "14px" }}>
          {VISIBILITY_VIDEOS.slice(0, 2).map((v) => (
            <button
              key={v.label}
              className="btn btn-primary"
              style={{
                flex: 1,
                fontSize: "12px",
                padding: "16px 0",
                borderRadius: "12px",
              }}
              onClick={() => setActiveVisVideo(v)}
            >
              {v.label}
            </button>
          ))}
        </div>
        {/* Row 2 — 1 button centered */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            className="btn btn-primary"
            style={{
              fontSize: "12px",
              padding: "16px 16px",
              borderRadius: "12px",
            }}
            onClick={() => setActiveVisVideo(VISIBILITY_VIDEOS[2])}
          >
            {VISIBILITY_VIDEOS[2].label}
          </button>
        </div>
      </div>

      <h3
        className="text-uppercase mb-2 mt-2"
        style={{ fontWeight: 900, fontSize: "1.5rem" }}
      >
        STUDY YOUR TRAINING VIDEOS
      </h3>

      <div
        className="d-flex justify-content-center mb-3 p-1"
        style={{ width: "100%" }}
      >
        {youtubeLinks.map((link, index) => (
          <a
            key={index}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-decoration-none mx-2"
          >
            <Button
              style={customButtonStyle}
              size="sm"
              className="d-flex align-items-center justify-content-center"
            >
              {index + 1}
            </Button>
          </a>
        ))}
      </div>

      <div className="d-flex flex-wrap mb-3 mt-2" style={{ gap: "4px" }}>
        <Link
          to="1on1Chat"
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
        >
          1 on 1 CHAT
        </Link>
        <Link
          to="groupChat"
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
        >
          GROUP CHAT
        </Link>
        <Link
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          to="Momentos"
        >
          MEMENTOS
        </Link>
        <Link
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          to="/trending"
        >
          Trending
        </Link>
        <Link
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          to="/badges"
        >
          TALKING BADGES
        </Link>
        <Link
          to="talent-contest"
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
        >
          Talent Contest
        </Link>
        <a
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          href="https://youtu.be/EeYu-JoUn2E"
          target="_blank"
          rel="noopener noreferrer"
        >
          FHP
        </a>
        <Link
          to="overview"
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
        >
          Overview
        </Link>
        <Link
          to="blogs"
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
        >
          FHP News
        </Link>
        <Link
          to="/endorsement"
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
        >
          Endorsements
        </Link>
        <a
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          href="https://youtube.com/shorts/I4UkxBL4lAA"
          target="_blank"
          rel="noopener noreferrer"
        >
          NOTIFICATIONS
        </a>
        <Link
          to="seasonal-system"
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
        >
          Seasonal System
        </Link>
        <Link
          to="/sport-badges"
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
        >
          Sport Badges
        </Link>
        <a
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          href="https://youtube.com/shorts/5QE8OEDKHnQ"
          target="_blank"
          rel="noopener noreferrer"
        >
          BUILD SPIRIT
        </a>
        <a
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          href="https://youtu.be/NMC9k-PjDw4"
          target="_blank"
          rel="noopener noreferrer"
        >
          LEARN FAST
        </a>
        <Link
          to="/verify-endorsements"
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
        >
          Verify Endorsements
        </Link>
        <a
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          href="https://youtu.be/vKhWi7YwmMs"
          target="_blank"
          rel="noopener noreferrer"
        >
          Athletes Build Brand
        </a>
        <a
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          href="https://youtu.be/oLTEAYipCB0"
          target="_blank"
          rel="noopener noreferrer"
        >
          Happy
        </a>
        <Link
          to="manager"
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
        >
          Managers
        </Link>       
        <a
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          href="https://youtu.be/oXCL-MeCWD4"
          target="_blank"
          rel="noopener noreferrer"
        >
          WE THE FANS
        </a>
        <a
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          href="https://youtube.com/shorts/tpLSLDk7tD8"
          target="_blank"
          rel="noopener noreferrer"
        >
          Athlete's Blog
        </a>
        <Link
          to="/news-suggestions"
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
        >
          News Suggestions
        </Link>     
        <a
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          href="https://youtube.com/shorts/I4UkxBL4lAA"
          target="_blank"
          rel="noopener noreferrer"
        >
          SHORTCUTS
        </a>
        <a
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          href="https://youtu.be/4MB8TMLsSWQ"
          target="_blank"
          rel="noopener noreferrer"
        >
          FAN FUN
        </a>
        <a
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          href="https://youtu.be/mQyGcaUsJmI"
          target="_blank"
          rel="noopener noreferrer"
        >
          GRANDMOTHER
        </a>
        <a
          className="text-white btn btn-primary my-0"
          style={{ flex: "1 1 auto" }}
          href="https://youtube.com/shorts/3y30CPIp4Jk"
          target="_blank"
          rel="noopener noreferrer"
        >
          Athlete Boost Nil $
        </a>
      </div>

      <a
        href="https://youtu.be/u0FJb_04Mp4"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://youtu.be/vy3CB-v5NFw
      </a>

      <div>
        <Button color="primary" size="sm" className="text-white my-1">
          <a
            className="text-white text-decoration-none"
            href="https://youtu.be/GX3NwHYYFp8"
            target="_blank"
            rel="noopener noreferrer"
          >
            About us
          </a>
        </Button>
      </div>
      <div className="my-2">
        <img src={Logo} alt="logo" className="img-fluid" />
      </div>

      <div>
        <a
          className="text-white btn btn-primary px-2 mt-2 mb-1"
          href="https://www.youtube.com/shorts/zoANXOxPc9g"
          target="_blank"
          rel="noopener noreferrer"
        >
          Explainer Video
        </a>
        <a
          className="text-white btn btn-primary px-2 mt-2 mb-1"
          onClick={() => {
            Modaltoggle();
            setCurrentVideoIndex(0);
          }}
        >
          Meet Our Athletes Carousel
        </a>
      </div>

      <Modal
        isOpen={!!activeVisVideo}
        toggle={() => setActiveVisVideo(null)}
        centered
        size="lg"
      >
        <ModalHeader
          toggle={() => setActiveVisVideo(null)}
          style={{ borderBottom: "none", paddingBottom: 0 }}
        >
          {activeVisVideo?.label}
        </ModalHeader>
        <ModalBody className="p-2">
          {activeVisVideo && (
            <video
              src={activeVisVideo.url}
              controls
              autoPlay
              style={{ width: "100%", borderRadius: "8px", maxHeight: "70vh" }}
            />
          )}
        </ModalBody>
      </Modal>

      <strong className="text-danger">
        <i>Click for info</i>
      </strong>
      <br />
      <i className="fas fa-arrow-circle-down text-danger"></i>
      <br />
      <a
        href="https://youtu.be/bDdM9ZweBgI"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://youtu.be/bDdM9ZweBgI
      </a>
    </Col>
  );
}
